import { render, staticRenderFns } from "./EnviarEncuesta.vue?vue&type=template&id=55cffe16&"
import script from "./EnviarEncuesta.vue?vue&type=script&lang=js&"
export * from "./EnviarEncuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports